import { Image, Waypoint } from './index.js'

export default class Trip {
  constructor({ id, title = 'My Trip', subtitle, coverImage, zoomOptions, waypoints = [] } = {}) {
    this.id = id
    this.title = title
    this.subtitle = subtitle
    this.waypoints = waypoints
    this.coverImage = coverImage
    this.zoomOptions = zoomOptions
  }

  static fromJson(json) {
    return new Trip({
      id: json.id,
      title: json.title,
      subtitle: json.subtitle,
      zoomOptions: json.zoomOptions,
      coverImage: json.coverImage ? Image.fromJson(json.coverImage) : null,
      waypoints: json.waypoints?.map(Waypoint.fromJson)
    })
  }
}
